import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class NavigationController extends Controller {
  onToggle(event) {
    const { target } = event;

    this.toggleDropdown(target.parentNode);

    this.closeAllDropdowns(target.parentNode);

    // Event.detail is 0 when the toggle is triggered by keyboard.
    const eventInteractionType = typeof event.detail !== 'undefined' && event.detail === 0
      ? 'keyboard'
      : 'mouse';

    if (eventInteractionType === 'keyboard') {
      this.markKeyboardNavigation(true);
    }

    if (eventInteractionType === 'mouse' && this.navigationResponsiveState() === 'lg') {
      this.markKeyboardNavigation(false);

      if (event.target.getAttribute('data-href')) {
        window.location = event.target.getAttribute('data-href');
      }
    }
  }

  onWindowKeyup(event) {
    if (typeof event.key !== 'undefined' && event.key === 'Escape') {
      const dropdownElement = this.element.querySelector('.is-open');

      if (dropdownElement) {
        this.toggleDropdown(dropdownElement, false);
        dropdownElement.parentNode.querySelector('button');
      }
    }
  }

  onWindowClick(event) {
    if (this.navigationResponsiveState() === 'sm') {
      return;
    }

    const dropdownItem = event.target.closest('.is-open');

    if (!dropdownItem) {
      this.closeAllDropdowns();
    }
  }

  onDropdownLinkBlur(event) {
    const dropdownMenu = event.target.closest('.dropdown-menu');
    const { children } = dropdownMenu;
    const lastChild = children[children.length - 1];

    if (dropdownMenu && lastChild === event.target.parentNode) {
      this.toggleDropdown(dropdownMenu.parentNode, false, false);
    }
  }

  closeAllDropdowns(except = null) {
    const openDropdowns = toArray(this.element.querySelectorAll('.nav-item.is-open'));

    openDropdowns.forEach((openDropdown) => {
      if (except && openDropdown === except) {
        return;
      }

      this.toggleDropdown(openDropdown, false, false);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  toggleDropdown(dropdownElement, toggleState = null, moveFocus = true) {
    const newState = toggleState !== null
      ? toggleState
      : !dropdownElement.classList.contains('is-open');

    dropdownElement.classList[newState ? 'add' : 'remove']('is-open');

    const toggleButton = dropdownElement.querySelector('button');

    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', newState ? 'true' : 'false');

      if (!newState && moveFocus) {
        toggleButton.focus();
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  navigationResponsiveState() {
    return window.innerWidth >= 992 ? 'lg' : 'sm';
  }

  markKeyboardNavigation(state) {
    this.element.classList[state ? 'add' : 'remove']('is-keyboard');
  }
}

export default NavigationController;
